export default "<div class=\"card card-border-radius\">\n  <div #container></div>\n</div>\n";